import { lazy } from 'react';
const Balcony = lazy(() => import(
// webpackChunkName: 'Balcony'
'./icons/balcony.svg'));
const Balcony1 = lazy(() => import(
// webpackChunkName: 'Balcony1'
'./icons/balcony1.svg'));
const Balcony2 = lazy(() => import(
// webpackChunkName: 'Balcony2'
'./icons/balcony2.svg'));
const Balcony3 = lazy(() => import(
// webpackChunkName: 'Balcony3'
'./icons/balcony3.svg'));
const Balcony4 = lazy(() => import(
// webpackChunkName: 'Balcony4'
'./icons/balcony4.svg'));
const Balcony5 = lazy(() => import(
// webpackChunkName: 'Balcony5'
'./icons/balcony5.svg'));
const Bar = lazy(() => import(
// webpackChunkName: 'Bar'
'./icons/bar.svg'));
const Bar1 = lazy(() => import(
// webpackChunkName: 'Bar1'
'./icons/bar1.svg'));
const Bar2 = lazy(() => import(
// webpackChunkName: 'Bar2'
'./icons/bar2.svg'));
const Bar3 = lazy(() => import(
// webpackChunkName: 'Bar3'
'./icons/bar3.svg'));
const Bar4 = lazy(() => import(
// webpackChunkName: 'Bar4'
'./icons/bar4.svg'));
const Bar5 = lazy(() => import(
// webpackChunkName: 'Bar5'
'./icons/bar5.svg'));
const Bathhouse = lazy(() => import(
// webpackChunkName: 'Bathhouse'
'./icons/bathhouse.svg'));
const Bathhouse1 = lazy(() => import(
// webpackChunkName: 'Bathhouse1'
'./icons/bathhouse1.svg'));
const Bathhouse2 = lazy(() => import(
// webpackChunkName: 'Bathhouse2'
'./icons/bathhouse2.svg'));
const Bathhouse3 = lazy(() => import(
// webpackChunkName: 'Bathhouse3'
'./icons/bathhouse3.svg'));
const Bathhouse4 = lazy(() => import(
// webpackChunkName: 'Bathhouse4'
'./icons/bathhouse4.svg'));
const Bathhouse5 = lazy(() => import(
// webpackChunkName: 'Bathhouse5'
'./icons/bathhouse5.svg'));
const Bathroom = lazy(() => import(
// webpackChunkName: 'Bathroom'
'./icons/bathroom.svg'));
const Bathroom1 = lazy(() => import(
// webpackChunkName: 'Bathroom1'
'./icons/bathroom1.svg'));
const Bathroom2 = lazy(() => import(
// webpackChunkName: 'Bathroom2'
'./icons/bathroom2.svg'));
const Bathroom3 = lazy(() => import(
// webpackChunkName: 'Bathroom3'
'./icons/bathroom3.svg'));
const Bathroom4 = lazy(() => import(
// webpackChunkName: 'Bathroom4'
'./icons/bathroom4.svg'));
const Bathroom5 = lazy(() => import(
// webpackChunkName: 'Bathroom5'
'./icons/bathroom5.svg'));
const Boilerroom = lazy(() => import(
// webpackChunkName: 'Boilerroom'
'./icons/boilerroom.svg'));
const Boilerroom1 = lazy(() => import(
// webpackChunkName: 'Boilerroom1'
'./icons/boilerroom1.svg'));
const Boilerroom2 = lazy(() => import(
// webpackChunkName: 'Boilerroom2'
'./icons/boilerroom2.svg'));
const Boilerroom3 = lazy(() => import(
// webpackChunkName: 'Boilerroom3'
'./icons/boilerroom3.svg'));
const Boilerroom4 = lazy(() => import(
// webpackChunkName: 'Boilerroom4'
'./icons/boilerroom4.svg'));
const Boilerroom5 = lazy(() => import(
// webpackChunkName: 'Boilerroom5'
'./icons/boilerroom5.svg'));
const Cabinet = lazy(() => import(
// webpackChunkName: 'Cabinet'
'./icons/cabinet.svg'));
const Cabinet1 = lazy(() => import(
// webpackChunkName: 'Cabinet1'
'./icons/cabinet1.svg'));
const Cabinet2 = lazy(() => import(
// webpackChunkName: 'Cabinet2'
'./icons/cabinet2.svg'));
const Cabinet3 = lazy(() => import(
// webpackChunkName: 'Cabinet3'
'./icons/cabinet3.svg'));
const Cabinet4 = lazy(() => import(
// webpackChunkName: 'Cabinet4'
'./icons/cabinet4.svg'));
const Cabinet5 = lazy(() => import(
// webpackChunkName: 'Cabinet5'
'./icons/cabinet5.svg'));
const Children = lazy(() => import(
// webpackChunkName: 'Children'
'./icons/children.svg'));
const Children1 = lazy(() => import(
// webpackChunkName: 'Children1'
'./icons/children1.svg'));
const Children2 = lazy(() => import(
// webpackChunkName: 'Children2'
'./icons/children2.svg'));
const Children3 = lazy(() => import(
// webpackChunkName: 'Children3'
'./icons/children3.svg'));
const Children4 = lazy(() => import(
// webpackChunkName: 'Children4'
'./icons/children4.svg'));
const Children5 = lazy(() => import(
// webpackChunkName: 'Children5'
'./icons/children5.svg'));
const Cinema = lazy(() => import(
// webpackChunkName: 'Cinema'
'./icons/cinema.svg'));
const Cinema1 = lazy(() => import(
// webpackChunkName: 'Cinema1'
'./icons/cinema1.svg'));
const Cinema2 = lazy(() => import(
// webpackChunkName: 'Cinema2'
'./icons/cinema2.svg'));
const Cinema3 = lazy(() => import(
// webpackChunkName: 'Cinema3'
'./icons/cinema3.svg'));
const Cinema4 = lazy(() => import(
// webpackChunkName: 'Cinema4'
'./icons/cinema4.svg'));
const Cinema5 = lazy(() => import(
// webpackChunkName: 'Cinema5'
'./icons/cinema5.svg'));
const Corridor = lazy(() => import(
// webpackChunkName: 'Corridor'
'./icons/corridor.svg'));
const Corridor1 = lazy(() => import(
// webpackChunkName: 'Corridor1'
'./icons/corridor1.svg'));
const Corridor2 = lazy(() => import(
// webpackChunkName: 'Corridor2'
'./icons/corridor2.svg'));
const Corridor3 = lazy(() => import(
// webpackChunkName: 'Corridor3'
'./icons/corridor3.svg'));
const Corridor4 = lazy(() => import(
// webpackChunkName: 'Corridor4'
'./icons/corridor4.svg'));
const Corridor5 = lazy(() => import(
// webpackChunkName: 'Corridor5'
'./icons/corridor5.svg'));
const Garage = lazy(() => import(
// webpackChunkName: 'Garage'
'./icons/garage.svg'));
const Garage1 = lazy(() => import(
// webpackChunkName: 'Garage1'
'./icons/garage1.svg'));
const Garage2 = lazy(() => import(
// webpackChunkName: 'Garage2'
'./icons/garage2.svg'));
const Garage3 = lazy(() => import(
// webpackChunkName: 'Garage3'
'./icons/garage3.svg'));
const Garage4 = lazy(() => import(
// webpackChunkName: 'Garage4'
'./icons/garage4.svg'));
const Garage5 = lazy(() => import(
// webpackChunkName: 'Garage5'
'./icons/garage5.svg'));
const Gazebo = lazy(() => import(
// webpackChunkName: 'Gazebo'
'./icons/gazebo.svg'));
const Gazebo1 = lazy(() => import(
// webpackChunkName: 'Gazebo1'
'./icons/gazebo1.svg'));
const Gazebo2 = lazy(() => import(
// webpackChunkName: 'Gazebo2'
'./icons/gazebo2.svg'));
const Gazebo3 = lazy(() => import(
// webpackChunkName: 'Gazebo3'
'./icons/gazebo3.svg'));
const Gazebo4 = lazy(() => import(
// webpackChunkName: 'Gazebo4'
'./icons/gazebo4.svg'));
const Gazebo5 = lazy(() => import(
// webpackChunkName: 'Gazebo5'
'./icons/gazebo5.svg'));
const Kitchen = lazy(() => import(
// webpackChunkName: 'Kitchen'
'./icons/kitchen.svg'));
const Kitchen1 = lazy(() => import(
// webpackChunkName: 'Kitchen1'
'./icons/kitchen1.svg'));
const Kitchen2 = lazy(() => import(
// webpackChunkName: 'Kitchen2'
'./icons/kitchen2.svg'));
const Kitchen3 = lazy(() => import(
// webpackChunkName: 'Kitchen3'
'./icons/kitchen3.svg'));
const Kitchen4 = lazy(() => import(
// webpackChunkName: 'Kitchen4'
'./icons/kitchen4.svg'));
const Kitchen5 = lazy(() => import(
// webpackChunkName: 'Kitchen5'
'./icons/kitchen5.svg'));
const Livingroom = lazy(() => import(
// webpackChunkName: 'Livingroom'
'./icons/livingroom.svg'));
const Livingroom1 = lazy(() => import(
// webpackChunkName: 'Livingroom1'
'./icons/livingroom1.svg'));
const Livingroom2 = lazy(() => import(
// webpackChunkName: 'Livingroom2'
'./icons/livingroom2.svg'));
const Livingroom3 = lazy(() => import(
// webpackChunkName: 'Livingroom3'
'./icons/livingroom3.svg'));
const Livingroom4 = lazy(() => import(
// webpackChunkName: 'Livingroom4'
'./icons/livingroom4.svg'));
const Livingroom5 = lazy(() => import(
// webpackChunkName: 'Livingroom5'
'./icons/livingroom5.svg'));
const Playroom = lazy(() => import(
// webpackChunkName: 'Playroom'
'./icons/playroom.svg'));
const Playroom1 = lazy(() => import(
// webpackChunkName: 'Playroom1'
'./icons/playroom1.svg'));
const Playroom2 = lazy(() => import(
// webpackChunkName: 'Playroom2'
'./icons/playroom2.svg'));
const Playroom3 = lazy(() => import(
// webpackChunkName: 'Playroom3'
'./icons/playroom3.svg'));
const Playroom4 = lazy(() => import(
// webpackChunkName: 'Playroom4'
'./icons/playroom4.svg'));
const Playroom5 = lazy(() => import(
// webpackChunkName: 'Playroom5'
'./icons/playroom5.svg'));
const Pool = lazy(() => import(
// webpackChunkName: 'Pool'
'./icons/pool.svg'));
const Pool1 = lazy(() => import(
// webpackChunkName: 'Pool1'
'./icons/pool1.svg'));
const Pool2 = lazy(() => import(
// webpackChunkName: 'Pool2'
'./icons/pool2.svg'));
const Pool3 = lazy(() => import(
// webpackChunkName: 'Pool3'
'./icons/pool3.svg'));
const Pool4 = lazy(() => import(
// webpackChunkName: 'Pool4'
'./icons/pool4.svg'));
const Pool5 = lazy(() => import(
// webpackChunkName: 'Pool5'
'./icons/pool5.svg'));
const Stairs = lazy(() => import(
// webpackChunkName: 'Stairs'
'./icons/stairs.svg'));
const Stairs1 = lazy(() => import(
// webpackChunkName: 'Stairs1'
'./icons/stairs1.svg'));
const Stairs2 = lazy(() => import(
// webpackChunkName: 'Stairs2'
'./icons/stairs2.svg'));
const Stairs3 = lazy(() => import(
// webpackChunkName: 'Stairs3'
'./icons/stairs3.svg'));
const Stairs4 = lazy(() => import(
// webpackChunkName: 'Stairs4'
'./icons/stairs4.svg'));
const Stairs5 = lazy(() => import(
// webpackChunkName: 'Stairs5'
'./icons/stairs5.svg'));
const Veranda = lazy(() => import(
// webpackChunkName: 'Veranda'
'./icons/veranda.svg'));
const Veranda1 = lazy(() => import(
// webpackChunkName: 'Veranda1'
'./icons/veranda1.svg'));
const Veranda2 = lazy(() => import(
// webpackChunkName: 'Veranda2'
'./icons/veranda2.svg'));
const Veranda3 = lazy(() => import(
// webpackChunkName: 'Veranda3'
'./icons/veranda3.svg'));
const Veranda4 = lazy(() => import(
// webpackChunkName: 'Veranda4'
'./icons/veranda4.svg'));
const Veranda5 = lazy(() => import(
// webpackChunkName: 'Veranda5'
'./icons/veranda5.svg'));
const Wardrobe = lazy(() => import(
// webpackChunkName: 'Wardrobe'
'./icons/wardrobe.svg'));
const Wardrobe1 = lazy(() => import(
// webpackChunkName: 'Wardrobe1'
'./icons/wardrobe1.svg'));
const Wardrobe2 = lazy(() => import(
// webpackChunkName: 'Wardrobe2'
'./icons/wardrobe2.svg'));
const Wardrobe3 = lazy(() => import(
// webpackChunkName: 'Wardrobe3'
'./icons/wardrobe3.svg'));
const Wardrobe4 = lazy(() => import(
// webpackChunkName: 'Wardrobe4'
'./icons/wardrobe4.svg'));
const Wardrobe5 = lazy(() => import(
// webpackChunkName: 'Wardrobe5'
'./icons/wardrobe5.svg'));
const Wintergarden = lazy(() => import(
// webpackChunkName: 'Wintergarden'
'./icons/wintergarden.svg'));
const Wintergarden1 = lazy(() => import(
// webpackChunkName: 'Wintergarden1'
'./icons/wintergarden1.svg'));
const Wintergarden2 = lazy(() => import(
// webpackChunkName: 'Wintergarden2'
'./icons/wintergarden2.svg'));
const Wintergarden3 = lazy(() => import(
// webpackChunkName: 'Wintergarden3'
'./icons/wintergarden3.svg'));
const Wintergarden4 = lazy(() => import(
// webpackChunkName: 'Wintergarden4'
'./icons/wintergarden4.svg'));
const Wintergarden5 = lazy(() => import(
// webpackChunkName: 'Wintergarden5'
'./icons/wintergarden5.svg'));
const Attic = lazy(() => import(
// webpackChunkName: 'Attic'
'./icons/attic.svg'));
const Attic1 = lazy(() => import(
// webpackChunkName: 'Attic1'
'./icons/attic1.svg'));
const Attic2 = lazy(() => import(
// webpackChunkName: 'Attic2'
'./icons/attic2.svg'));
const Attic3 = lazy(() => import(
// webpackChunkName: 'Attic3'
'./icons/attic3.svg'));
const Attic4 = lazy(() => import(
// webpackChunkName: 'Attic4'
'./icons/attic4.svg'));
const Attic5 = lazy(() => import(
// webpackChunkName: 'Attic5'
'./icons/attic5.svg'));
const Basement = lazy(() => import(
// webpackChunkName: 'Basement'
'./icons/basement.svg'));
const Basement1 = lazy(() => import(
// webpackChunkName: 'Basement1'
'./icons/basement1.svg'));
const Basement2 = lazy(() => import(
// webpackChunkName: 'Basement2'
'./icons/basement2.svg'));
const Basement3 = lazy(() => import(
// webpackChunkName: 'Basement3'
'./icons/basement3.svg'));
const Basement4 = lazy(() => import(
// webpackChunkName: 'Basement4'
'./icons/basement4.svg'));
const Basement5 = lazy(() => import(
// webpackChunkName: 'Basement5'
'./icons/basement5.svg'));
const Bedroom = lazy(() => import(
// webpackChunkName: 'Bedroom'
'./icons/bedroom.svg'));
const Bedroom1 = lazy(() => import(
// webpackChunkName: 'Bedroom1'
'./icons/bedroom1.svg'));
const Bedroom2 = lazy(() => import(
// webpackChunkName: 'Bedroom2'
'./icons/bedroom2.svg'));
const Bedroom3 = lazy(() => import(
// webpackChunkName: 'Bedroom3'
'./icons/bedroom3.svg'));
const Bedroom4 = lazy(() => import(
// webpackChunkName: 'Bedroom4'
'./icons/bedroom4.svg'));
const Bedroom5 = lazy(() => import(
// webpackChunkName: 'Bedroom5'
'./icons/bedroom5.svg'));
const Diningroom = lazy(() => import(
// webpackChunkName: 'Diningroom'
'./icons/diningroom.svg'));
const Diningroom1 = lazy(() => import(
// webpackChunkName: 'Diningroom1'
'./icons/diningroom1.svg'));
const Diningroom2 = lazy(() => import(
// webpackChunkName: 'Diningroom2'
'./icons/diningroom2.svg'));
const Diningroom3 = lazy(() => import(
// webpackChunkName: 'Diningroom3'
'./icons/diningroom3.svg'));
const Diningroom4 = lazy(() => import(
// webpackChunkName: 'Diningroom4'
'./icons/diningroom4.svg'));
const Diningroom5 = lazy(() => import(
// webpackChunkName: 'Diningroom5'
'./icons/diningroom5.svg'));
const Floor = lazy(() => import(
// webpackChunkName: 'Floor'
'./icons/floor.svg'));
const Floor1 = lazy(() => import(
// webpackChunkName: 'Floor1'
'./icons/floor1.svg'));
const Floor2 = lazy(() => import(
// webpackChunkName: 'Floor2'
'./icons/floor2.svg'));
const Floor3 = lazy(() => import(
// webpackChunkName: 'Floor3'
'./icons/floor3.svg'));
const Floor4 = lazy(() => import(
// webpackChunkName: 'Floor4'
'./icons/floor4.svg'));
const Floor5 = lazy(() => import(
// webpackChunkName: 'Floor5'
'./icons/floor5.svg'));
const Garden = lazy(() => import(
// webpackChunkName: 'Garden'
'./icons/garden.svg'));
const Garden1 = lazy(() => import(
// webpackChunkName: 'Garden1'
'./icons/garden1.svg'));
const Garden2 = lazy(() => import(
// webpackChunkName: 'Garden2'
'./icons/garden2.svg'));
const Garden3 = lazy(() => import(
// webpackChunkName: 'Garden3'
'./icons/garden3.svg'));
const Garden4 = lazy(() => import(
// webpackChunkName: 'Garden4'
'./icons/garden4.svg'));
const Garden5 = lazy(() => import(
// webpackChunkName: 'Garden5'
'./icons/garden5.svg'));
const Greenhouse = lazy(() => import(
// webpackChunkName: 'Greenhouse'
'./icons/greenhouse.svg'));
const Greenhouse1 = lazy(() => import(
// webpackChunkName: 'Greenhouse1'
'./icons/greenhouse1.svg'));
const Greenhouse2 = lazy(() => import(
// webpackChunkName: 'Greenhouse2'
'./icons/greenhouse2.svg'));
const Greenhouse3 = lazy(() => import(
// webpackChunkName: 'Greenhouse3'
'./icons/greenhouse3.svg'));
const Greenhouse4 = lazy(() => import(
// webpackChunkName: 'Greenhouse4'
'./icons/greenhouse4.svg'));
const Greenhouse5 = lazy(() => import(
// webpackChunkName: 'Greenhouse5'
'./icons/greenhouse5.svg'));
const Groundfloor = lazy(() => import(
// webpackChunkName: 'Groundfloor'
'./icons/groundfloor.svg'));
const Groundfloor1 = lazy(() => import(
// webpackChunkName: 'Groundfloor1'
'./icons/groundfloor1.svg'));
const Groundfloor2 = lazy(() => import(
// webpackChunkName: 'Groundfloor2'
'./icons/groundfloor2.svg'));
const Groundfloor3 = lazy(() => import(
// webpackChunkName: 'Groundfloor3'
'./icons/groundfloor3.svg'));
const Groundfloor4 = lazy(() => import(
// webpackChunkName: 'Groundfloor4'
'./icons/groundfloor4.svg'));
const Groundfloor5 = lazy(() => import(
// webpackChunkName: 'Groundfloor5'
'./icons/groundfloor5.svg'));
const Hallway = lazy(() => import(
// webpackChunkName: 'Hallway'
'./icons/hallway.svg'));
const Hallway1 = lazy(() => import(
// webpackChunkName: 'Hallway1'
'./icons/hallway1.svg'));
const Hallway2 = lazy(() => import(
// webpackChunkName: 'Hallway2'
'./icons/hallway2.svg'));
const Hallway3 = lazy(() => import(
// webpackChunkName: 'Hallway3'
'./icons/hallway3.svg'));
const Hallway4 = lazy(() => import(
// webpackChunkName: 'Hallway4'
'./icons/hallway4.svg'));
const Hallway5 = lazy(() => import(
// webpackChunkName: 'Hallway5'
'./icons/hallway5.svg'));
const Hammam = lazy(() => import(
// webpackChunkName: 'Hammam'
'./icons/hammam.svg'));
const Hammam1 = lazy(() => import(
// webpackChunkName: 'Hammam1'
'./icons/hammam1.svg'));
const Hammam2 = lazy(() => import(
// webpackChunkName: 'Hammam2'
'./icons/hammam2.svg'));
const Hammam3 = lazy(() => import(
// webpackChunkName: 'Hammam3'
'./icons/hammam3.svg'));
const Hammam4 = lazy(() => import(
// webpackChunkName: 'Hammam4'
'./icons/hammam4.svg'));
const Hammam5 = lazy(() => import(
// webpackChunkName: 'Hammam5'
'./icons/hammam5.svg'));
const Mansard = lazy(() => import(
// webpackChunkName: 'Mansard'
'./icons/mansard.svg'));
const Mansard1 = lazy(() => import(
// webpackChunkName: 'Mansard1'
'./icons/mansard1.svg'));
const Mansard2 = lazy(() => import(
// webpackChunkName: 'Mansard2'
'./icons/mansard2.svg'));
const Mansard3 = lazy(() => import(
// webpackChunkName: 'Mansard3'
'./icons/mansard3.svg'));
const Mansard4 = lazy(() => import(
// webpackChunkName: 'Mansard4'
'./icons/mansard4.svg'));
const Mansard5 = lazy(() => import(
// webpackChunkName: 'Mansard5'
'./icons/mansard5.svg'));
const Sauna = lazy(() => import(
// webpackChunkName: 'Sauna'
'./icons/sauna.svg'));
const Sauna1 = lazy(() => import(
// webpackChunkName: 'Sauna1'
'./icons/sauna1.svg'));
const Sauna2 = lazy(() => import(
// webpackChunkName: 'Sauna2'
'./icons/sauna2.svg'));
const Sauna3 = lazy(() => import(
// webpackChunkName: 'Sauna3'
'./icons/sauna3.svg'));
const Sauna4 = lazy(() => import(
// webpackChunkName: 'Sauna4'
'./icons/sauna4.svg'));
const Sauna5 = lazy(() => import(
// webpackChunkName: 'Sauna5'
'./icons/sauna5.svg'));
const Sport = lazy(() => import(
// webpackChunkName: 'Sport'
'./icons/sport.svg'));
const Sport1 = lazy(() => import(
// webpackChunkName: 'Sport1'
'./icons/sport1.svg'));
const Sport2 = lazy(() => import(
// webpackChunkName: 'Sport2'
'./icons/sport2.svg'));
const Sport3 = lazy(() => import(
// webpackChunkName: 'Sport3'
'./icons/sport3.svg'));
const Sport4 = lazy(() => import(
// webpackChunkName: 'Sport4'
'./icons/sport4.svg'));
const Sport5 = lazy(() => import(
// webpackChunkName: 'Sport5'
'./icons/sport5.svg'));
const Terrace = lazy(() => import(
// webpackChunkName: 'Terrace'
'./icons/terrace.svg'));
const Terrace1 = lazy(() => import(
// webpackChunkName: 'Terrace1'
'./icons/terrace1.svg'));
const Terrace2 = lazy(() => import(
// webpackChunkName: 'Terrace2'
'./icons/terrace2.svg'));
const Terrace3 = lazy(() => import(
// webpackChunkName: 'Terrace3'
'./icons/terrace3.svg'));
const Terrace4 = lazy(() => import(
// webpackChunkName: 'Terrace4'
'./icons/terrace4.svg'));
const Terrace5 = lazy(() => import(
// webpackChunkName: 'Terrace5'
'./icons/terrace5.svg'));
const Tire = lazy(() => import(
// webpackChunkName: 'Tire'
'./icons/tire.svg'));
const Tire1 = lazy(() => import(
// webpackChunkName: 'Tire1'
'./icons/tire1.svg'));
const Tire2 = lazy(() => import(
// webpackChunkName: 'Tire2'
'./icons/tire2.svg'));
const Tire3 = lazy(() => import(
// webpackChunkName: 'Tire3'
'./icons/tire3.svg'));
const Tire4 = lazy(() => import(
// webpackChunkName: 'Tire4'
'./icons/tire4.svg'));
const Tire5 = lazy(() => import(
// webpackChunkName: 'Tire5'
'./icons/tire5.svg'));
const Toilet = lazy(() => import(
// webpackChunkName: 'Toilet'
'./icons/toilet.svg'));
const Toilet1 = lazy(() => import(
// webpackChunkName: 'Toilet1'
'./icons/toilet1.svg'));
const Toilet2 = lazy(() => import(
// webpackChunkName: 'Toilet2'
'./icons/toilet2.svg'));
const Toilet3 = lazy(() => import(
// webpackChunkName: 'Toilet3'
'./icons/toilet3.svg'));
const Toilet4 = lazy(() => import(
// webpackChunkName: 'Toilet4'
'./icons/toilet4.svg'));
const Toilet5 = lazy(() => import(
// webpackChunkName: 'Toilet5'
'./icons/toilet5.svg'));
const Vestibule = lazy(() => import(
// webpackChunkName: 'Vestibule'
'./icons/vestibule.svg'));
const Vestibule1 = lazy(() => import(
// webpackChunkName: 'Vestibule1'
'./icons/vestibule1.svg'));
const Vestibule2 = lazy(() => import(
// webpackChunkName: 'Vestibule2'
'./icons/vestibule2.svg'));
const Vestibule3 = lazy(() => import(
// webpackChunkName: 'Vestibule3'
'./icons/vestibule3.svg'));
const Vestibule4 = lazy(() => import(
// webpackChunkName: 'Vestibule4'
'./icons/vestibule4.svg'));
const Vestibule5 = lazy(() => import(
// webpackChunkName: 'Vestibule5'
'./icons/vestibule5.svg'));
const Workshop = lazy(() => import(
// webpackChunkName: 'Workshop'
'./icons/workshop.svg'));
const Workshop1 = lazy(() => import(
// webpackChunkName: 'Workshop1'
'./icons/workshop1.svg'));
const Workshop2 = lazy(() => import(
// webpackChunkName: 'Workshop2'
'./icons/workshop2.svg'));
const Workshop3 = lazy(() => import(
// webpackChunkName: 'Workshop3'
'./icons/workshop3.svg'));
const Workshop4 = lazy(() => import(
// webpackChunkName: 'Workshop4'
'./icons/workshop4.svg'));
const Workshop5 = lazy(() => import(
// webpackChunkName: 'Workshop5'
'./icons/workshop5.svg'));
const BoilerGas1 = lazy(() => import(
// webpackChunkName: 'BoilerGas1'
'./icons/boiler-gas1.svg'));
const BoilerGas2 = lazy(() => import(
// webpackChunkName: 'BoilerGas2'
'./icons/boiler-gas2.svg'));
const BoilerGas3 = lazy(() => import(
// webpackChunkName: 'BoilerGas3'
'./icons/boiler-gas3.svg'));
const BoilerGas4 = lazy(() => import(
// webpackChunkName: 'BoilerGas4'
'./icons/boiler-gas4.svg'));
const BoilerGas5 = lazy(() => import(
// webpackChunkName: 'BoilerGas5'
'./icons/boiler-gas5.svg'));
const BoilerEl1 = lazy(() => import(
// webpackChunkName: 'BoilerEl1'
'./icons/boiler-electro1.svg'));
const BoilerEl2 = lazy(() => import(
// webpackChunkName: 'BoilerEl2'
'./icons/boiler-electro2.svg'));
const BoilerEl3 = lazy(() => import(
// webpackChunkName: 'BoilerEl3'
'./icons/boiler-electro3.svg'));
const BoilerEl4 = lazy(() => import(
// webpackChunkName: 'BoilerEl4'
'./icons/boiler-electro4.svg'));
const BoilerEl5 = lazy(() => import(
// webpackChunkName: 'BoilerEl5'
'./icons/boiler-electro5.svg'));
const AirConditioner1 = lazy(() => import(
// webpackChunkName: 'AirConditioner1'
'./icons/conditioner1.svg'));
const AirConditioner2 = lazy(() => import(
// webpackChunkName: 'AirConditioner2'
'./icons/conditioner2.svg'));
const AirConditioner3 = lazy(() => import(
// webpackChunkName: 'AirConditioner3'
'./icons/conditioner3.svg'));
const AirConditioner4 = lazy(() => import(
// webpackChunkName: 'AirConditioner4'
'./icons/conditioner4.svg'));
const AirConditioner5 = lazy(() => import(
// webpackChunkName: 'AirConditioner5'
'./icons/conditioner5.svg'));
const Convector1 = lazy(() => import(
// webpackChunkName: 'Convector1'
'./icons/convector1.svg'));
const Convector2 = lazy(() => import(
// webpackChunkName: 'Convector2'
'./icons/convector2.svg'));
const Convector3 = lazy(() => import(
// webpackChunkName: 'Convector3'
'./icons/convector3.svg'));
const Convector4 = lazy(() => import(
// webpackChunkName: 'Convector4'
'./icons/convector4.svg'));
const Convector5 = lazy(() => import(
// webpackChunkName: 'Convector5'
'./icons/convector5.svg'));
const Heater1 = lazy(() => import(
// webpackChunkName: 'Heater1'
'./icons/heater1.svg'));
const Heater2 = lazy(() => import(
// webpackChunkName: 'Heater2'
'./icons/heater2.svg'));
const Heater3 = lazy(() => import(
// webpackChunkName: 'Heater3'
'./icons/heater3.svg'));
const Heater4 = lazy(() => import(
// webpackChunkName: 'Heater4'
'./icons/heater4.svg'));
const Heater5 = lazy(() => import(
// webpackChunkName: 'Heater5'
'./icons/heater5.svg'));
const Radiator1 = lazy(() => import(
// webpackChunkName: 'Radiator1'
'./icons/radiator1.svg'));
const Radiator2 = lazy(() => import(
// webpackChunkName: 'Radiator2'
'./icons/radiator2.svg'));
const Radiator3 = lazy(() => import(
// webpackChunkName: 'Radiator3'
'./icons/radiator3.svg'));
const Radiator4 = lazy(() => import(
// webpackChunkName: 'Radiator4'
'./icons/radiator4.svg'));
const Radiator5 = lazy(() => import(
// webpackChunkName: 'Radiator5'
'./icons/radiator5.svg'));
const Lamp1 = lazy(() => import(
// webpackChunkName: 'Lamp1'
'./icons/lamp1.svg'));
const Lamp2 = lazy(() => import(
// webpackChunkName: 'Lamp2'
'./icons/lamp2.svg'));
const Lamp3 = lazy(() => import(
// webpackChunkName: 'Lamp3'
'./icons/lamp3.svg'));
const Lamp4 = lazy(() => import(
// webpackChunkName: 'Lamp4'
'./icons/lamp4.svg'));
const Lamp5 = lazy(() => import(
// webpackChunkName: 'Lamp5'
'./icons/lamp5.svg'));
const Socket1 = lazy(() => import(
// webpackChunkName: 'Socket1'
'./icons/socket1.svg'));
const Socket2 = lazy(() => import(
// webpackChunkName: 'Socket2'
'./icons/socket2.svg'));
const Socket3 = lazy(() => import(
// webpackChunkName: 'Socket3'
'./icons/socket3.svg'));
const Socket4 = lazy(() => import(
// webpackChunkName: 'Socket4'
'./icons/socket4.svg'));
const Socket5 = lazy(() => import(
// webpackChunkName: 'Socket5'
'./icons/socket5.svg'));
const Pump1 = lazy(() => import(
// webpackChunkName: 'Pump1'
'./icons/pump1.svg'));
const Pump2 = lazy(() => import(
// webpackChunkName: 'Pump2'
'./icons/pump2.svg'));
const Pump3 = lazy(() => import(
// webpackChunkName: 'Pump3'
'./icons/pump3.svg'));
const Pump4 = lazy(() => import(
// webpackChunkName: 'Pump4'
'./icons/pump4.svg'));
const Pump5 = lazy(() => import(
// webpackChunkName: 'Pump5'
'./icons/pump5.svg'));
const RelayOff1 = lazy(() => import(
// webpackChunkName: 'RelayOff1'
'./icons/relay-off1.svg'));
const RelayOff2 = lazy(() => import(
// webpackChunkName: 'RelayOff2'
'./icons/relay-off2.svg'));
const RelayOff3 = lazy(() => import(
// webpackChunkName: 'RelayOff3'
'./icons/relay-off3.svg'));
const RelayOff4 = lazy(() => import(
// webpackChunkName: 'RelayOff4'
'./icons/relay-off4.svg'));
const RelayOff5 = lazy(() => import(
// webpackChunkName: 'RelayOff5'
'./icons/relay-off5.svg'));
const V220 = lazy(() => import(
// webpackChunkName: 'V220'
'./icons/220v.svg'));
const V380 = lazy(() => import(
// webpackChunkName: 'V380'
'./icons/380v.svg'));
const Commutator = lazy(() => import(
// webpackChunkName: 'Commutator'
'./icons/commutator.svg'));
const Dvr = lazy(() => import(
// webpackChunkName: 'Dvr'
'./icons/dvr.svg'));
const Elock = lazy(() => import(
// webpackChunkName: 'Elock'
'./icons/elock.svg'));
const Ont = lazy(() => import(
// webpackChunkName: 'Ont'
'./icons/ont.svg'));
const Spotlight = lazy(() => import(
// webpackChunkName: 'Spotlight'
'./icons/spotlight.svg'));
const Solid = lazy(() => import(
// webpackChunkName: 'Solid'
'./icons/solid.svg'));
const Hydro1 = lazy(() => import(
// webpackChunkName: 'Hydro1'
'./icons/hydro1.svg'));
const Hydro2 = lazy(() => import(
// webpackChunkName: 'Hydro2'
'./icons/hydro2.svg'));
const Hydro3 = lazy(() => import(
// webpackChunkName: 'Hydro3'
'./icons/hydro3.svg'));
export const tariff_icons = [
    {
        id: 17,
        render: Balcony,
        title: 'Балкон',
        paid: true,
        similar: [17, 18, 19, 20, 21, 22],
    },
    {
        id: 18,
        render: Balcony1,
        title: 'Балкон 1',
        paid: true,
    },
    {
        id: 19,
        render: Balcony2,
        title: 'Балкон 2',
        paid: true,
    },
    {
        id: 20,
        render: Balcony3,
        title: 'Балкон 3',
        paid: true,
    },
    {
        id: 21,
        render: Balcony4,
        title: 'Балкон 4',
        paid: true,
    },
    {
        id: 22,
        render: Balcony5,
        title: 'Балкон 5',
        paid: true,
    },
    {
        id: 23,
        render: Bar,
        title: 'Бар',
        paid: true,
        similar: [23, 24, 25, 26, 27, 28],
    },
    {
        id: 24,
        render: Bar1,
        title: 'Бар 1',
        paid: true,
    },
    {
        id: 25,
        render: Bar2,
        title: 'Бар 2',
        paid: true,
    },
    {
        id: 26,
        render: Bar3,
        title: 'Бар 3',
        paid: true,
    },
    {
        id: 27,
        render: Bar4,
        title: 'Бар 4',
        paid: true,
    },
    {
        id: 28,
        render: Bar5,
        title: 'Бар 5',
        paid: true,
    },
    {
        id: 29,
        render: Bathhouse,
        title: 'Баня',
        paid: true,
        similar: [29, 30, 31, 32, 33, 34],
    },
    {
        id: 30,
        render: Bathhouse1,
        title: 'Баня 1',
        paid: true,
    },
    {
        id: 31,
        render: Bathhouse2,
        title: 'Баня 2',
        paid: true,
    },
    {
        id: 32,
        render: Bathhouse3,
        title: 'Баня 3',
        paid: true,
    },
    {
        id: 33,
        render: Bathhouse4,
        title: 'Баня 4',
        paid: true,
    },
    {
        id: 34,
        render: Bathhouse5,
        title: 'Баня 5',
        paid: true,
    },
    {
        id: 35,
        render: Bathroom,
        title: 'Ванная',
        paid: true,
        similar: [35, 36, 37, 38, 39, 40],
    },
    {
        id: 36,
        render: Bathroom1,
        title: 'Ванная 1',
        paid: true,
    },
    {
        id: 37,
        render: Bathroom2,
        title: 'Ванная 2',
        paid: true,
    },
    {
        id: 38,
        render: Bathroom3,
        title: 'Ванная 3',
        paid: true,
    },
    {
        id: 39,
        render: Bathroom4,
        title: 'Ванная 4',
        paid: true,
    },
    {
        id: 40,
        render: Bathroom5,
        title: 'Ванная 5',
        paid: true,
    },
    {
        id: 41,
        render: Boilerroom,
        title: 'Котельная',
        paid: true,
        similar: [41, 42, 43, 44, 45, 46],
    },
    {
        id: 42,
        render: Boilerroom1,
        title: 'Котельная 1',
        paid: true,
    },
    {
        id: 43,
        render: Boilerroom2,
        title: 'Котельная 2',
        paid: true,
    },
    {
        id: 44,
        render: Boilerroom3,
        title: 'Котельная 3',
        paid: true,
    },
    {
        id: 45,
        render: Boilerroom4,
        title: 'Котельная 4',
        paid: true,
    },
    {
        id: 46,
        render: Boilerroom5,
        title: 'Котельная 5',
        paid: true,
    },
    {
        id: 47,
        render: Cabinet,
        title: 'Кабинет',
        paid: true,
        similar: [47, 48, 49, 50, 51, 52],
    },
    {
        id: 48,
        render: Cabinet1,
        title: 'Кабинет 1',
        paid: true,
    },
    {
        id: 49,
        render: Cabinet2,
        title: 'Кабинет 2',
        paid: true,
    },
    {
        id: 50,
        render: Cabinet3,
        title: 'Кабинет 3',
        paid: true,
    },
    {
        id: 51,
        render: Cabinet4,
        title: 'Кабинет 4',
        paid: true,
    },
    {
        id: 52,
        render: Cabinet5,
        title: 'Кабинет 5',
        paid: true,
    },
    {
        id: 53,
        render: Children,
        title: 'Детская',
        paid: true,
        similar: [53, 54, 55, 56, 57, 58],
    },
    {
        id: 54,
        render: Children1,
        title: 'Детская 1',
        paid: true,
    },
    {
        id: 55,
        render: Children2,
        title: 'Детская 2',
        paid: true,
    },
    {
        id: 56,
        render: Children3,
        title: 'Детская 3',
        paid: true,
    },
    {
        id: 57,
        render: Children4,
        title: 'Детская 4',
        paid: true,
    },
    {
        id: 58,
        render: Children5,
        title: 'Детская 5',
        paid: true,
    },
    {
        id: 59,
        render: Cinema,
        title: 'Кино(театр)',
        paid: true,
        similar: [59, 60, 61, 62, 63, 64],
    },
    {
        id: 60,
        render: Cinema1,
        title: 'Кино(театр) 1',
        paid: true,
    },
    {
        id: 61,
        render: Cinema2,
        title: 'Кино(театр) 2',
        paid: true,
    },
    {
        id: 62,
        render: Cinema3,
        title: 'Кино(театр) 3',
        paid: true,
    },
    {
        id: 63,
        render: Cinema4,
        title: 'Кино(театр) 4',
        paid: true,
    },
    {
        id: 64,
        render: Cinema5,
        title: 'Кино(театр) 5',
        paid: true,
    },
    {
        id: 65,
        render: Corridor,
        title: 'Коридор',
        paid: true,
        similar: [65, 66, 67, 68, 69, 70],
    },
    {
        id: 66,
        render: Corridor1,
        title: 'Коридор 1',
        paid: true,
    },
    {
        id: 67,
        render: Corridor2,
        title: 'Коридор 2',
        paid: true,
    },
    {
        id: 68,
        render: Corridor3,
        title: 'Коридор 3',
        paid: true,
    },
    {
        id: 69,
        render: Corridor4,
        title: 'Коридор 4',
        paid: true,
    },
    {
        id: 70,
        render: Corridor5,
        title: 'Коридор 5',
        paid: true,
    },
    {
        id: 71,
        render: Garage,
        title: 'Гараж',
        paid: true,
        similar: [71, 72, 73, 74, 75, 76],
    },
    {
        id: 72,
        render: Garage1,
        title: 'Гараж 1',
        paid: true,
    },
    {
        id: 73,
        render: Garage2,
        title: 'Гараж 2',
        paid: true,
    },
    {
        id: 74,
        render: Garage3,
        title: 'Гараж 3',
        paid: true,
    },
    {
        id: 75,
        render: Garage4,
        title: 'Гараж 4',
        paid: true,
    },
    {
        id: 76,
        render: Garage5,
        title: 'Гараж 5',
        paid: true,
    },
    {
        id: 77,
        render: Gazebo,
        title: 'Беседка',
        paid: true,
        similar: [77, 78, 79, 80, 81, 82],
    },
    {
        id: 78,
        render: Gazebo1,
        title: 'Беседка 1',
        paid: true,
    },
    {
        id: 79,
        render: Gazebo2,
        title: 'Беседка 2',
        paid: true,
    },
    {
        id: 80,
        render: Gazebo3,
        title: 'Беседка 3',
        paid: true,
    },
    {
        id: 81,
        render: Gazebo4,
        title: 'Беседка 4',
        paid: true,
    },
    {
        id: 82,
        render: Gazebo5,
        title: 'Беседка 5',
        paid: true,
    },
    {
        id: 83,
        render: Kitchen,
        title: 'Кухня',
        paid: true,
        similar: [83, 84, 85, 86, 87, 88],
    },
    {
        id: 84,
        render: Kitchen1,
        title: 'Кухня 1',
        paid: true,
    },
    {
        id: 85,
        render: Kitchen2,
        title: 'Кухня 2',
        paid: true,
    },
    {
        id: 86,
        render: Kitchen3,
        title: 'Кухня 3',
        paid: true,
    },
    {
        id: 87,
        render: Kitchen4,
        title: 'Кухня 4',
        paid: true,
    },
    {
        id: 88,
        render: Kitchen5,
        title: 'Кухня 5',
        paid: true,
    },
    {
        id: 89,
        render: Livingroom,
        title: 'Гостиная',
        paid: true,
        similar: [89, 90, 91, 92, 93, 94],
    },
    {
        id: 90,
        render: Livingroom1,
        title: 'Гостиная 1',
        paid: true,
    },
    {
        id: 91,
        render: Livingroom2,
        title: 'Гостиная 2',
        paid: true,
    },
    {
        id: 92,
        render: Livingroom3,
        title: 'Гостиная 3',
        paid: true,
    },
    {
        id: 93,
        render: Livingroom4,
        title: 'Гостиная 4',
        paid: true,
    },
    {
        id: 94,
        render: Livingroom5,
        title: 'Гостиная 5',
        paid: true,
    },
    {
        id: 95,
        render: Playroom,
        title: 'Игровая',
        paid: true,
        similar: [95, 96, 97, 98, 99, 100],
    },
    {
        id: 96,
        render: Playroom1,
        title: 'Игровая 1',
        paid: true,
    },
    {
        id: 97,
        render: Playroom2,
        title: 'Игровая 2',
        paid: true,
    },
    {
        id: 98,
        render: Playroom3,
        title: 'Игровая 3',
        paid: true,
    },
    {
        id: 99,
        render: Playroom4,
        title: 'Игровая 4',
        paid: true,
    },
    {
        id: 100,
        render: Playroom5,
        title: 'Игровая 5',
        paid: true,
    },
    {
        id: 101,
        render: Pool,
        title: 'Бассейн',
        paid: true,
    },
    {
        id: 102,
        render: Pool1,
        title: 'Бассейн 1',
        paid: true,
    },
    {
        id: 103,
        render: Pool2,
        title: 'Бассейн 2',
        paid: true,
    },
    {
        id: 104,
        render: Pool3,
        title: 'Бассейн 3',
        paid: true,
    },
    {
        id: 105,
        render: Pool4,
        title: 'Бассейн 4',
        paid: true,
    },
    {
        id: 106,
        render: Pool5,
        title: 'Бассейн 5',
        paid: true,
    },
    {
        id: 107,
        render: Stairs,
        title: 'Лестница',
        paid: true,
        similar: [107, 108, 109, 110, 111, 112],
    },
    {
        id: 108,
        render: Stairs1,
        title: 'Лестница 1',
        paid: true,
    },
    {
        id: 109,
        render: Stairs2,
        title: 'Лестница 2',
        paid: true,
    },
    {
        id: 110,
        render: Stairs3,
        title: 'Лестница 3',
        paid: true,
    },
    {
        id: 111,
        render: Stairs4,
        title: 'Лестница 4',
        paid: true,
    },
    {
        id: 112,
        render: Stairs5,
        title: 'Лестница 5',
        paid: true,
    },
    {
        id: 113,
        render: Veranda,
        title: 'Веранда',
        paid: true,
        similar: [113, 114, 115, 116, 117, 118],
    },
    {
        id: 114,
        render: Veranda1,
        title: 'Веранда 1',
        paid: true,
    },
    {
        id: 115,
        render: Veranda2,
        title: 'Веранда 2',
        paid: true,
    },
    {
        id: 116,
        render: Veranda3,
        title: 'Веранда 3',
        paid: true,
    },
    {
        id: 117,
        render: Veranda4,
        title: 'Веранда 4',
        paid: true,
    },
    {
        id: 118,
        render: Veranda5,
        title: 'Веранда 5',
        paid: true,
    },
    {
        id: 119,
        render: Wardrobe,
        title: 'Гардероб',
        paid: true,
        similar: [119, 120, 121, 122, 123, 124],
    },
    {
        id: 120,
        render: Wardrobe1,
        title: 'Гардероб 1',
        paid: true,
    },
    {
        id: 121,
        render: Wardrobe2,
        title: 'Гардероб 2',
        paid: true,
    },
    {
        id: 122,
        render: Wardrobe3,
        title: 'Гардероб 3',
        paid: true,
    },
    {
        id: 123,
        render: Wardrobe4,
        title: 'Гардероб 4',
        paid: true,
    },
    {
        id: 124,
        render: Wardrobe5,
        title: 'Гардероб 5',
        paid: true,
    },
    {
        id: 125,
        render: Wintergarden,
        title: 'Зимний сад',
        paid: true,
        similar: [125, 126, 127, 128, 129, 130],
    },
    {
        id: 126,
        render: Wintergarden1,
        title: 'Зимний сад 1',
        paid: true,
    },
    {
        id: 127,
        render: Wintergarden2,
        title: 'Зимний сад 2',
        paid: true,
    },
    {
        id: 128,
        render: Wintergarden3,
        title: 'Зимний сад 3',
        paid: true,
    },
    {
        id: 129,
        render: Wintergarden4,
        title: 'Зимний сад 4',
        paid: true,
    },
    {
        id: 130,
        render: Wintergarden5,
        title: 'Зимний сад 5',
        paid: true,
    },
    {
        id: 131,
        render: Basement,
        title: 'Подвал',
        paid: true,
        similar: [131, 132, 133, 134, 135, 136],
    },
    {
        id: 132,
        render: Basement1,
        title: 'Подвал 1',
        paid: true,
    },
    {
        id: 133,
        render: Basement2,
        title: 'Подвал 2',
        paid: true,
    },
    {
        id: 134,
        render: Basement3,
        title: 'Подвал 3',
        paid: true,
    },
    {
        id: 135,
        render: Basement4,
        title: 'Подвал 4',
        paid: true,
    },
    {
        id: 136,
        render: Basement5,
        title: 'Подвал 5',
        paid: true,
    },
    {
        id: 137,
        render: Attic,
        title: 'Чердак',
        paid: true,
        similar: [137, 138, 139, 140, 141, 142],
    },
    {
        id: 138,
        render: Attic1,
        title: 'Чердак 1',
        paid: true,
    },
    {
        id: 139,
        render: Attic2,
        title: 'Чердак 2',
        paid: true,
    },
    {
        id: 140,
        render: Attic3,
        title: 'Чердак 3',
        paid: true,
    },
    {
        id: 141,
        render: Attic4,
        title: 'Чердак 4',
        paid: true,
    },
    {
        id: 142,
        render: Attic5,
        title: 'Чердак 5',
        paid: true,
    },
    {
        id: 143,
        render: Bedroom,
        title: 'Спальня',
        paid: true,
        similar: [143, 144, 145, 146, 147, 148],
    },
    {
        id: 144,
        render: Bedroom1,
        title: 'Спальня 1',
        paid: true,
    },
    {
        id: 145,
        render: Bedroom2,
        title: 'Спальня 2',
        paid: true,
    },
    {
        id: 146,
        render: Bedroom3,
        title: 'Спальня 3',
        paid: true,
    },
    {
        id: 147,
        render: Bedroom4,
        title: 'Спальня 4',
        paid: true,
    },
    {
        id: 148,
        render: Bedroom5,
        title: 'Спальня 5',
        paid: true,
    },
    {
        id: 149,
        render: Diningroom,
        title: 'Столовая',
        paid: true,
        similar: [149, 150, 151, 152, 153, 154],
    },
    {
        id: 150,
        render: Diningroom1,
        title: 'Столовая 1',
        paid: true,
    },
    {
        id: 151,
        render: Diningroom2,
        title: 'Столовая 2',
        paid: true,
    },
    {
        id: 152,
        render: Diningroom3,
        title: 'Столовая 3',
        paid: true,
    },
    {
        id: 153,
        render: Diningroom4,
        title: 'Столовая 4',
        paid: true,
    },
    {
        id: 154,
        render: Diningroom5,
        title: 'Столовая 5',
        paid: true,
    },
    {
        id: 155,
        render: Floor,
        title: 'Этаж',
        paid: true,
        similar: [155, 156, 157, 158, 159, 160],
    },
    {
        id: 156,
        render: Floor1,
        title: 'Этаж 1',
        paid: true,
    },
    {
        id: 157,
        render: Floor2,
        title: 'Этаж 2',
        paid: true,
    },
    {
        id: 158,
        render: Floor3,
        title: 'Этаж 3',
        paid: true,
    },
    {
        id: 159,
        render: Floor4,
        title: 'Этаж 4',
        paid: true,
    },
    {
        id: 160,
        render: Floor5,
        title: 'Этаж 5',
        paid: true,
    },
    {
        id: 161,
        render: Garden,
        title: 'Сад',
        paid: true,
        similar: [161, 162, 163, 164, 165, 166],
    },
    {
        id: 162,
        render: Garden1,
        title: 'Сад 1',
        paid: true,
    },
    {
        id: 163,
        render: Garden2,
        title: 'Сад 2',
        paid: true,
    },
    {
        id: 164,
        render: Garden3,
        title: 'Сад 3',
        paid: true,
    },
    {
        id: 165,
        render: Garden4,
        title: 'Сад 4',
        paid: true,
    },
    {
        id: 166,
        render: Garden5,
        title: 'Сад 5',
        paid: true,
    },
    {
        id: 167,
        render: Greenhouse,
        title: 'Теплица',
        paid: true,
    },
    {
        id: 168,
        render: Greenhouse1,
        title: 'Теплица 1',
        paid: true,
    },
    {
        id: 169,
        render: Greenhouse2,
        title: 'Теплица 2',
        paid: true,
    },
    {
        id: 170,
        render: Greenhouse3,
        title: 'Теплица 3',
        paid: true,
    },
    {
        id: 171,
        render: Greenhouse4,
        title: 'Теплица 4',
        paid: true,
    },
    {
        id: 172,
        render: Greenhouse5,
        title: 'Теплица 5',
        paid: true,
    },
    {
        id: 173,
        render: Groundfloor,
        title: 'Цоколь',
        paid: true,
        similar: [173, 174, 175, 176, 177, 178],
    },
    {
        id: 174,
        render: Groundfloor1,
        title: 'Цоколь 1',
        paid: true,
    },
    {
        id: 175,
        render: Groundfloor2,
        title: 'Цоколь 2',
        paid: true,
    },
    {
        id: 176,
        render: Groundfloor3,
        title: 'Цоколь 3',
        paid: true,
    },
    {
        id: 177,
        render: Groundfloor4,
        title: 'Цоколь 4',
        paid: true,
    },
    {
        id: 178,
        render: Groundfloor5,
        title: 'Цоколь 5',
        paid: true,
    },
    {
        id: 179,
        render: Hallway,
        title: 'Прихожая',
        paid: true,
        similar: [179, 180, 181, 182, 183, 184],
    },
    {
        id: 180,
        render: Hallway1,
        title: 'Прихожая 1',
        paid: true,
    },
    {
        id: 181,
        render: Hallway2,
        title: 'Прихожая 2',
        paid: true,
    },
    {
        id: 182,
        render: Hallway3,
        title: 'Прихожая 3',
        paid: true,
    },
    {
        id: 183,
        render: Hallway4,
        title: 'Прихожая 4',
        paid: true,
    },
    {
        id: 184,
        render: Hallway5,
        title: 'Прихожая 5',
        paid: true,
    },
    {
        id: 185,
        render: Hammam,
        title: 'Хаммам',
        paid: true,
        similar: [185, 186, 187, 188, 189, 190],
    },
    {
        id: 186,
        render: Hammam1,
        title: 'Хаммам 1',
        paid: true,
    },
    {
        id: 187,
        render: Hammam2,
        title: 'Хаммам 2',
        paid: true,
    },
    {
        id: 188,
        render: Hammam3,
        title: 'Хаммам 3',
        paid: true,
    },
    {
        id: 189,
        render: Hammam4,
        title: 'Хаммам 4',
        paid: true,
    },
    {
        id: 190,
        render: Hammam5,
        title: 'Хаммам 5',
        paid: true,
    },
    {
        id: 191,
        render: Mansard,
        title: 'Мансарда',
        paid: true,
        similar: [191, 192, 193, 194, 195, 196],
    },
    {
        id: 192,
        render: Mansard1,
        title: 'Мансарда 1',
        paid: true,
    },
    {
        id: 193,
        render: Mansard2,
        title: 'Мансарда 2',
        paid: true,
    },
    {
        id: 194,
        render: Mansard3,
        title: 'Мансарда 3',
        paid: true,
    },
    {
        id: 195,
        render: Mansard4,
        title: 'Мансарда 4',
        paid: true,
    },
    {
        id: 196,
        render: Mansard5,
        title: 'Мансарда 5',
        paid: true,
    },
    {
        id: 197,
        render: Sauna,
        title: 'Сауна',
        paid: true,
        similar: [197, 198, 199, 200, 201, 202],
    },
    {
        id: 198,
        render: Sauna1,
        title: 'Сауна 1',
        paid: true,
    },
    {
        id: 199,
        render: Sauna2,
        title: 'Сауна 2',
        paid: true,
    },
    {
        id: 200,
        render: Sauna3,
        title: 'Сауна 3',
        paid: true,
    },
    {
        id: 201,
        render: Sauna4,
        title: 'Сауна 4',
        paid: true,
    },
    {
        id: 202,
        render: Sauna5,
        title: 'Сауна 5',
        paid: true,
    },
    {
        id: 203,
        render: Sport,
        title: 'Спортзал',
        paid: true,
        similar: [203, 204, 205, 206, 207, 208],
    },
    {
        id: 204,
        render: Sport1,
        title: 'Спортзал 1',
        paid: true,
    },
    {
        id: 205,
        render: Sport2,
        title: 'Спортзал 2',
        paid: true,
    },
    {
        id: 206,
        render: Sport3,
        title: 'Спортзал 3',
        paid: true,
    },
    {
        id: 207,
        render: Sport4,
        title: 'Спортзал 4',
        paid: true,
    },
    {
        id: 208,
        render: Sport5,
        title: 'Спортзал 5',
        paid: true,
    },
    {
        id: 209,
        render: Terrace,
        title: 'Терраса',
        paid: true,
        similar: [209, 210, 211, 212, 213, 214],
    },
    {
        id: 210,
        render: Terrace1,
        title: 'Терраса 1',
        paid: true,
    },
    {
        id: 211,
        render: Terrace2,
        title: 'Терраса 2',
        paid: true,
    },
    {
        id: 212,
        render: Terrace3,
        title: 'Терраса 3',
        paid: true,
    },
    {
        id: 213,
        render: Terrace4,
        title: 'Терраса 4',
        paid: true,
    },
    {
        id: 214,
        render: Terrace5,
        title: 'Терраса 5',
        paid: true,
    },
    {
        id: 215,
        render: Tire,
        title: 'Шиномонтаж',
        paid: true,
        similar: [215, 216, 217, 218, 219, 220],
    },
    {
        id: 216,
        render: Tire1,
        title: 'Шиномонтаж 1',
        paid: true,
    },
    {
        id: 217,
        render: Tire2,
        title: 'Шиномонтаж 2',
        paid: true,
    },
    {
        id: 218,
        render: Tire3,
        title: 'Шиномонтаж 3',
        paid: true,
    },
    {
        id: 219,
        render: Tire4,
        title: 'Шиномонтаж 4',
        paid: true,
    },
    {
        id: 220,
        render: Tire5,
        title: 'Шиномонтаж 5',
        paid: true,
    },
    {
        id: 221,
        render: Toilet,
        title: 'Санузел',
        paid: true,
        similar: [221, 222, 223, 224, 225, 226],
    },
    {
        id: 222,
        render: Toilet1,
        title: 'Санузел 1',
        paid: true,
    },
    {
        id: 223,
        render: Toilet2,
        title: 'Санузел 2',
        paid: true,
    },
    {
        id: 224,
        render: Toilet3,
        title: 'Санузел 3',
        paid: true,
    },
    {
        id: 225,
        render: Toilet4,
        title: 'Санузел 4',
        paid: true,
    },
    {
        id: 226,
        render: Toilet5,
        title: 'Санузел 5',
        paid: true,
    },
    {
        id: 227,
        render: Vestibule,
        title: 'Тамбур',
        paid: true,
        similar: [227, 228, 229, 230, 231, 232],
    },
    {
        id: 228,
        render: Vestibule1,
        title: 'Тамбур 1',
        paid: true,
    },
    {
        id: 229,
        render: Vestibule2,
        title: 'Тамбур 2',
        paid: true,
    },
    {
        id: 230,
        render: Vestibule3,
        title: 'Тамбур 3',
        paid: true,
    },
    {
        id: 231,
        render: Vestibule4,
        title: 'Тамбур 4',
        paid: true,
    },
    {
        id: 232,
        render: Vestibule5,
        title: 'Тамбур 5',
        paid: true,
    },
    {
        id: 233,
        render: Workshop,
        title: 'Цех(мастерская)',
        paid: true,
        similar: [233, 234, 235, 236, 237, 238],
    },
    {
        id: 234,
        render: Workshop1,
        title: 'Цех(мастерская) 1',
        paid: true,
    },
    {
        id: 235,
        render: Workshop2,
        title: 'Цех(мастерская) 2',
        paid: true,
    },
    {
        id: 236,
        render: Workshop3,
        title: 'Цех(мастерская) 3',
        paid: true,
    },
    {
        id: 237,
        render: Workshop4,
        title: 'Цех(мастерская) 4',
        paid: true,
    },
    {
        id: 238,
        render: Workshop5,
        title: 'Цех(мастерская) 5',
        paid: true,
    },
    {
        id: 239,
        render: V220,
        title: '220 вольт',
        paid: true,
        similar: [239, 339],
    },
    {
        id: 240,
        render: V380,
        title: '380 вольт',
        paid: true,
        similar: [240, 340],
    },
    {
        id: 241,
        render: Commutator,
        title: 'Коммутатор',
        paid: true,
        similar: [241, 341],
    },
    {
        id: 242,
        render: Dvr,
        title: 'Видеорегистратор',
        paid: true,
        similar: [242, 342],
    },
    {
        id: 243,
        render: Elock,
        title: 'Элекромагнитный замок',
        paid: true,
        similar: [243, 344],
    },
    {
        id: 244,
        render: Ont,
        title: 'Оптический терминал',
        paid: true,
        similar: [244, 345],
    },
    {
        id: 245,
        render: Spotlight,
        title: 'Прожектор',
        paid: true,
        similar: [245, 343],
    },
    {
        id: 349,
        render: AirConditioner1,
        title: 'Кондиционер1',
        paid: true,
    },
    {
        id: 350,
        render: AirConditioner2,
        title: 'Кондиционер2',
        paid: true,
    },
    {
        id: 351,
        render: AirConditioner3,
        title: 'Кондиционер3',
        paid: true,
    },
    {
        id: 352,
        render: AirConditioner4,
        title: 'Кондиционер4',
        paid: true,
    },
    {
        id: 353,
        render: AirConditioner5,
        title: 'Кондиционер5',
        paid: true,
    },
    {
        id: 354,
        render: Convector1,
        title: 'Конвектор1',
        paid: true,
    },
    {
        id: 355,
        render: Convector2,
        title: 'Конвектор2',
        paid: true,
    },
    {
        id: 356,
        render: Convector3,
        title: 'Конвектор3',
        paid: true,
    },
    {
        id: 357,
        render: Convector4,
        title: 'Конвектор4',
        paid: true,
    },
    {
        id: 358,
        render: Convector5,
        title: 'Конвектор5',
        paid: true,
    },
    {
        id: 359,
        render: Heater1,
        title: 'Обогреватель1',
        paid: true,
    },
    {
        id: 360,
        render: Heater2,
        title: 'Обогреватель2',
        paid: true,
    },
    {
        id: 361,
        render: Heater3,
        title: 'Обогреватель3',
        paid: true,
    },
    {
        id: 362,
        render: Heater4,
        title: 'Обогреватель4',
        paid: true,
    },
    {
        id: 363,
        render: Heater5,
        title: 'Обогреватель5',
        paid: true,
    },
    {
        id: 364,
        render: Radiator1,
        title: 'Радиатор1',
        paid: true,
    },
    {
        id: 365,
        render: Radiator2,
        title: 'Радиатор2',
        paid: true,
    },
    {
        id: 366,
        render: Radiator3,
        title: 'Радиатор3',
        paid: true,
    },
    {
        id: 367,
        render: Radiator4,
        title: 'Радиатор4',
        paid: true,
    },
    {
        id: 368,
        render: Radiator5,
        title: 'Радиатор5',
        paid: true,
    },
    {
        id: 369,
        render: Lamp1,
        title: 'Светильник1',
        paid: true,
    },
    {
        id: 370,
        render: Lamp2,
        title: 'Светильник2',
        paid: true,
    },
    {
        id: 371,
        render: Lamp3,
        title: 'Светильник3',
        paid: true,
    },
    {
        id: 372,
        render: Lamp4,
        title: 'Светильник4',
        paid: true,
    },
    {
        id: 373,
        render: Lamp5,
        title: 'Светильник5',
        paid: true,
    },
    {
        id: 374,
        render: Socket1,
        title: 'Розетка1',
        paid: true,
    },
    {
        id: 375,
        render: Socket2,
        title: 'Розетка2',
        paid: true,
    },
    {
        id: 376,
        render: Socket3,
        title: 'Розетка3',
        paid: true,
    },
    {
        id: 377,
        render: Socket4,
        title: 'Розетка4',
        paid: true,
    },
    {
        id: 378,
        render: Socket5,
        title: 'Розетка5',
        paid: true,
    },
    {
        id: 379,
        render: Pump1,
        title: 'Насос1',
        paid: true,
    },
    {
        id: 380,
        render: Pump2,
        title: 'Насос2',
        paid: true,
    },
    {
        id: 381,
        render: Pump3,
        title: 'Насос3',
        paid: true,
    },
    {
        id: 382,
        render: Pump4,
        title: 'Насос4',
        paid: true,
    },
    {
        id: 383,
        render: Pump5,
        title: 'Насос5',
        paid: true,
    },
    {
        id: 384,
        render: RelayOff1,
        title: 'Реле1',
        paid: true,
    },
    {
        id: 385,
        render: RelayOff2,
        title: 'Реле2',
        paid: true,
    },
    {
        id: 386,
        render: RelayOff3,
        title: 'Реле3',
        paid: true,
    },
    {
        id: 387,
        render: RelayOff4,
        title: 'Реле4',
        paid: true,
    },
    {
        id: 388,
        render: RelayOff5,
        title: 'Реле5',
        paid: true,
    },
    {
        id: 389,
        render: BoilerGas1,
        title: 'Газовый котёл1',
        paid: true,
    },
    {
        id: 390,
        render: BoilerGas2,
        title: 'Газовый котёл2',
        paid: true,
    },
    {
        id: 391,
        render: BoilerGas3,
        title: 'Газовый котёл3',
        paid: true,
    },
    {
        id: 392,
        render: BoilerGas4,
        title: 'Газовый котёл4',
        paid: true,
    },
    {
        id: 393,
        render: BoilerGas5,
        title: 'Газовый котёл5',
        paid: true,
    },
    {
        id: 394,
        render: BoilerEl1,
        title: 'Электрический котёл1',
        paid: true,
    },
    {
        id: 395,
        render: BoilerEl2,
        title: 'Электрический котёл2',
        paid: true,
    },
    {
        id: 396,
        render: BoilerEl3,
        title: 'Электрический котёл3',
        paid: true,
    },
    {
        id: 397,
        render: BoilerEl4,
        title: 'Электрический котёл4',
        paid: true,
    },
    {
        id: 398,
        render: BoilerEl5,
        title: 'Электрический котёл5',
        paid: true,
    },
    {
        id: 399,
        render: Solid,
        title: 'Твердотопливный котёл',
        paid: true,
    },
    {
        id: 400,
        render: Hydro1,
        title: 'Гидрострелка 1 контур',
        paid: true,
    },
    {
        id: 401,
        render: Hydro2,
        title: 'Гидрострелка 2 контура',
        paid: true,
    },
    {
        id: 402,
        render: Hydro3,
        title: 'Гидрострелка 3 контура',
        paid: true,
    },
];
